import { makeStyles, Text, Title2 } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { dolphinTokens } from "../../../utils/Theme";

const useStyles = makeStyles({
    contentWrapper: {
        display: "flex",
        alignItems: "center",
        gap: "2rem",
        padding: "0 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
    },
    textContent: {
        flex: 1,
        maxWidth: "60%",
        
        "@media (max-width: 768px)": {
            maxWidth: "100%"
        }
    },
    title: {
        fontSize: "2.5rem",
        fontWeight: 600,
        lineHeight: 1.2,
        marginBottom: "1rem",
        color: "#333",

        "& .highlight": {
            color: dolphinTokens.colorLightBlue
        }
    },
    description: {
        fontSize: "1.125rem",
        color: "#495057",
        marginBottom: "2rem",
        lineHeight: 1.6
    },
    services: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "1rem"
    },
    service: {
        display: "flex",
        alignItems: "center"
    },
    checkmark: {
        width: "24px",
        height: "24px",
        borderRadius: "50%",
        backgroundColor: dolphinTokens.colorLightBlue20,
        color: dolphinTokens.colorLightBlue,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "0.5rem",
        fontSize: "0.875rem"
    },
    imageWrapper: {
        flexShrink: 0,
        width: "40%",
        maxWidth: "300px",
        "@media (max-width: 768px)": {
            display: "none"
        }
    },
    illustration: {
        width: "100%",
        height: "auto"
    }
});

const Service = (props: { text: string }) => {
    const styles = useStyles();

    return (
        <div className={styles.service}>
            <span className={styles.checkmark}>&#10003;</span>
            <span>{props.text}</span>
        </div>
    );
}

export default function Introduction() {
    const { t } = useTranslation("ourstory");
    const styles = useStyles();

    return (
        <div className={styles.contentWrapper}>
            <div className={styles.textContent}>
                <Title2 block as="h2" className={styles.title}>
                    <span dangerouslySetInnerHTML={{ __html: t("introduction.title") }} />
                </Title2>
                <Text block as="p" className={styles.description}>
                    <span dangerouslySetInnerHTML={{ __html: t("introduction.description") }} />
                </Text>
                <div className={styles.services}>
                    <Service text="Microsoft 365" />
                    <Service text="SharePoint" />
                    <Service text="Azure" />
                    <Service text="WEBCON BPS" />
                    <Service text="AI Adoption" />
                    <Service text="Bespoke Solution Development" />
                </div>
            </div>
            <div className={styles.imageWrapper}>
                <img src="/img/illustrations/illustration-1.png" className={styles.illustration} />
            </div>
        </div>
    );
};